import { Component, OnInit, Optional, Inject } from '@angular/core';
import { GridOptions, Module } from '@ag-grid-community/all-modules';
import { PershingTranslationService } from '@pershing/pershing-core';
import { PershingGridHeaderComponent } from '@pershing/pershing-grid2';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { Account } from '../../models/account.model';
import { AccountsResult } from '../../models/accounts-result.model';
import { Warning } from '../../models/warning.model';
import { EDeliveryService } from '../../services/edelivery.service';
import { AgreementService } from '../../services/agreement.service';
import { WarningService } from '../../services/warning.service';
import { GridDocumentsCellComponent } from '../gridDocumentsCell/grid-documents-cell.component';
import { ConfirmationComponent } from '../confirmationDialog/confirmation.component';
import { PershingError } from '@pershing/pershing-core';

@Component({
    selector: 'enroll',
    templateUrl: './enroll.component.html',
    styleUrls: ['./enroll.component.css']
})
export class EnrollComponent implements OnInit {

    preferencesResponse: Observable<AccountsResult>;
    gridOptions: GridOptions;
    response: any;
    originalResponse: any;
    loading: boolean = false;
    didUserEnroll: boolean = false;
    disableEnrollButton: boolean = true;
    preferencesCheckedCounter = 0;
    numberOfRows = 1;
    gridHeightVal = 60;
    getRowHeight: any;
    tabToNextCell: any;

    documentsPending: boolean = false;
    userFromMyClientView: boolean;
    public modules: Module[] = [ClientSideRowModelModule];

    warning: Warning;
    rowCounter: number = 0;
    expandRow: boolean = false;
    private subscription: Subscription;
    private disableSaveButtonSubscription: Subscription;
    private confirmationSubscription: Subscription;
    private _error: BehaviorSubject<PershingError>;
    private preferencesObservable: Subscription;
    private preferencesMobileObservable: Subscription;
    private rowTriggerSubscription: Subscription;
    private proxyWarningSubcription: Subscription;
    displayQPRDisclaimer: boolean;
    displayCommunicationTypesDisclaimer: boolean;
    updatePreferencesInProgressFlag: boolean = false;

    // Labels
    emailAddressInfo: any = EdeliveryLabels.EMAIL_ADDRESS_INFO;
    communicationTypes: any = EdeliveryLabels.COMMUNICATION_TYPES;
    QPRDisclaimer: any = EdeliveryLabels.QPR_DISCLAIMER;
    QPRDisclaimerEms: any = EdeliveryLabels.QPR_DISCLAIMER_EMS;
    reminder: any = EdeliveryLabels.REMINDER;
    reminderLabel: any = EdeliveryLabels.REMINDER_LABEL;
    emsReminderText: any = EdeliveryLabels.EMS_REMINDER;
    saveLabel: any = EdeliveryLabels.SAVE;
    saveNow: any = EdeliveryLabels.SAVE_NOW;
    cancelLabel = EdeliveryLabels.CANCEL;
    saveFirst: any = EdeliveryLabels.SAVE_FIRST;
    saveSecond: any = EdeliveryLabels.SAVE_SECOND;
    electronicAgreement: any = EdeliveryLabels.ELECTRONIC_AGREEMENT;
    saveThird: any = EdeliveryLabels.SAVE_THIRD;
    edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;

    pendingPreferencesDocName: any = EdeliveryLabels.DOCUMENT_NAME_PENDING;
    // viewPreferencesMessage1: any = EdeliveryLabels.VIEW_PREFERENCES_PENDING;
    viewPreferencesMessage2: any = EdeliveryLabels.VIEW_PREFERENCES_PENDING2;
    isLargeView: boolean = true;
    defaultPinValue = '0000';
    isNXIRequest: boolean  = true;

    constructor(private eDeliveryService: EDeliveryService, private agreementService: AgreementService, private warningService: WarningService,
                private translate: PershingTranslationService, private dialogRef: MatDialogRef<EnrollComponent>, private dialog: MatDialog,
                @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.deviceType === 'mobile') {
            this.isLargeView = false;
        }
        if (this.translate) {
            this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
        }
        if (appSettings.ibdConfigMap) {
            this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
          }
        this.getRowHeight = function(params) {
            let documents = params.data.eDeliveryDocuments.edeliveryDocuments;
            let rowHeight = 200;
            if (params.data.eDeliveryDocuments.edeliveryDocuments[6].docEligible === true) {
                rowHeight += 35;
            }
            // if (documents[5].preferenceType.deliveryPreference === 2 || documents[5].preferenceType.deliveryPreference === 4) {
            //     rowHeight += 65;
            //     if (this.rowClass === 'customWarning') {
            //         rowHeight += 50;
            //     }
            // }
            return rowHeight;
        };
        this.tabToNextCell = function(params) {};
        this.gridOptions = <GridOptions>{
            rowHeight: 200,
            headerHeight: 46,
            enableColResize: true,
            suppressMovableColumns: true,
            // rowModelType: 'normal',
            // suppressCellSelection: true,
            defaultColDef: {
                headerComponentFramework: PershingGridHeaderComponent
            },
            columnDefs: this.createColumnDefs(),
            overlayLoadingTemplate: '<div class="progress-spinner"></div>',
            onGridSizeChanged: () => {
                if (this.gridOptions.api) { this.gridOptions.api.sizeColumnsToFit(); }
            },
            onGridReady: ($event) => {
                if (!this.gridOptions.api) {
                    this.gridOptions.api = $event.api;
                }
                if (!this.gridOptions.columnApi) {
                    this.gridOptions.columnApi = $event.columnApi;
                }
                if (this.gridOptions.api !== undefined && this.response !== undefined) {
                    this.gridOptions.api.setRowData(this.formatRowData(this.response));
                    // scrolls to the first column
                    let firstCol = this.gridOptions.columnApi.getAllDisplayedColumns()[0];
                    this.gridOptions.api.ensureColumnVisible(firstCol);

                    // sets focus into the first grid cell
                    this.gridOptions.api.setFocusedCell(0, firstCol);
                }
                this.gridOptions.api.sizeColumnsToFit(); // Ensure columns are sized to fit the screen
            }
        };
    }

    ngOnInit(): void {
        this.isNXIRequest = this.eDeliveryService.isNXIRequest();
        this.disableEnrollButton = true;
        console.log('calling enroll');
        this.preferencesResponse = this.eDeliveryService.preferencesResponse$;
        this.subscription = this.preferencesResponse.subscribe(response => {
            if (response) {
                this.response = response;
                this.originalResponse = JSON.parse(JSON.stringify(this.response));
                this.eDeliveryService.trackingList = JSON.parse(JSON.stringify(this.response.accounts));
                this.findIfDocumentsArePending();
                if (this.gridOptions.api !== undefined) {
                    this.gridOptions.api.setRowData(this.formatRowData(this.response));
                    // scrolls to the first column
                    let firstCol = this.gridOptions.columnApi.getAllDisplayedColumns()[0];
                    this.gridOptions.api.ensureColumnVisible(firstCol);

                    // sets focus into the first grid cell
                    this.gridOptions.api.setFocusedCell(0, firstCol);
                }
                // this.documentsPending = this.eDeliveryService.documentsPending;
                this.displayQPRDisclaimer = this.eDeliveryService.displayQPRDisclaimer;
                this.displayCommunicationTypesDisclaimer = this.eDeliveryService.displayCommunicationTypesDisclaimer;
            }
        });
        this.eDeliveryService.retrievePreferences();
        this.disableSaveButtonSubscription = this.eDeliveryService.disableEnrollButton$.subscribe(response => {
            this.disableEnrollButton = response;
            console.log('response in disable button: ', response);
        });

        this.rowTriggerSubscription = this.eDeliveryService.triggerRowUpdate$.subscribe(response => {
            if (response) {
                this.gridOptions.api.resetRowHeights();
            } else if (response === false) {
                // this.gridOptions.rowClass = '';
                this.gridOptions.api.resetRowHeights();
            }
        });
        this.warning = new Warning('');
        this.proxyWarningSubcription = this.warningService.proxyWarning$.subscribe(warning => {
            // console.log('warning subscription getting called');
            if (warning) {
                this.warning.warningMessage = warning.warningMessage;
                this.gridOptions.rowClass = 'customWarning';
                this.gridOptions.api.resetRowHeights();
            }
        });
        // this.disableEnrollButton = this.eDeliveryService.disableEnrollButton;
    }

    findIfDocumentsArePending() {
        for (let i = 0; i < this.eDeliveryService.originalResponse.accounts.length; i++) {
            let currentAccount = this.eDeliveryService.originalResponse.accounts[i];
            for (let j = 0; j < currentAccount.edeliveryDocuments.length; j++) {
                let currentDoc = currentAccount.edeliveryDocuments[j];
                if (currentDoc.preferenceType.deliveryPreference === 4  && currentDoc.docEligible) {
                    this.documentsPending = true;
                    return;
                }
            }
        }
        this.documentsPending = false;
        return;
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.confirmationSubscription) {
            this.confirmationSubscription.unsubscribe();
        }
        if (this.disableSaveButtonSubscription) {
            this.disableSaveButtonSubscription.unsubscribe();
        }
        if (this.preferencesObservable) {
            this.preferencesObservable.unsubscribe();
        }
        if (this.preferencesMobileObservable) {
            this.preferencesMobileObservable.unsubscribe();
        }
        if (this.rowTriggerSubscription) {
            this.rowTriggerSubscription.unsubscribe();
        }
        if (this.proxyWarningSubcription) {
            this.proxyWarningSubcription.unsubscribe();
        }
        this.didUserEnroll = false;
        this.eDeliveryService.backButtonClicked = false;
        this.eDeliveryService.firstCellAccount = true;
    }

    createColumnDefs(): any[] {
        console.log('creating col defs');
        return [
            { headerName: EdeliveryLabels.ACCOUNT, maxWidth: 150, minWidth: 50, field: 'accountNumber', headerClass: 'left-align', cellClass: 'left-align' },
            {
                headerName: EdeliveryLabels.EDELIVERY_DOCUMENTS, minWidth: 130, autoHeight: true, field: 'eDeliveryDocuments', headerClass: 'left-align', displayType: 'edit',
                cellRendererFramework: GridDocumentsCellComponent
            }
        ];
    }

    // For Grid Accounts View
    formatRowData(response: AccountsResult): any[] {
        let rows: any[] = [];
        for (let i = 0; i < response.accounts.length; i++) {
            let accounts: Account = response.accounts[i];
            rows.push({
                accountNumber: accounts.accountNumber, // Name is composed of the document's description.
                eDeliveryDocuments: accounts
            });
        }
        this.numberOfRows = rows.length;
        return rows;
    }

    savePreferences() { // Need to refactor this code to make it like quickEnroll
        // this.preferencesCheckedCounter = 0;
        this.preferencesObservable = this.eDeliveryService.preferencesConfirmed$.subscribe(response => {
            // First time it triggers, it for some reason contains the previous data (so if i have 3 accounts, it actually counts as 4, hence the +1)
            // (need to figure out why it triggers the first time with invalid data)
            if (response && this.preferencesCheckedCounter !== 0 && this.preferencesCheckedCounter === this.response.accounts.length) {
                this.compareAndSubmit();
            } else if (!response && this.preferencesCheckedCounter !== 0) {
                // Remove observable
                this.preferencesCheckedCounter = 0;
                this.preferencesObservable.unsubscribe();
            } else {
                this.preferencesCheckedCounter++;
            }
        });
        this.eDeliveryService.preferencesSaved(true);
    }

    savePreferencesMobile() { // Need to refactor this code to make it like quickEnroll
        this.preferencesMobileObservable = this.eDeliveryService.preferencesConfirmedMobile$.subscribe(response => {
            // First time it triggers, it for some reason contains the previous data (so if i have 3 accounts, it actually counts as 4, hence the +1)
            // (need to figure out why it triggers the first time with invalid data)
            if (response && this.preferencesCheckedCounter === (this.response.accounts.length - 1)) {
                this.compareAndSubmit();
            } else if (!response) {
                // Remove observable
                this.preferencesCheckedCounter = 0;
                this.preferencesMobileObservable.unsubscribe();
            } else {
                this.preferencesCheckedCounter++;
            }
        });
        this.eDeliveryService.preferencesSaved(true);
    }

    goToAgreement(flag?) {
        this.agreementService.enableBackToEnrollment = true;
        if (flag) {
            this.eDeliveryService.stateCopyOfAccounts = JSON.parse(JSON.stringify(this.eDeliveryService.listOfAccountsChanged));
        }
        this.eDeliveryService.goToAgreement();
    }

    /** Compare current preferences to previous ones and go to agreement or proceed to submitting */
    compareAndSubmit(): void {
        let selectedArray = [];
        let selcCounter = 0;
        let listOfOriginalAccounts = JSON.parse(JSON.stringify(this.eDeliveryService.originalResponse));
        let listOfChangedAccounts = JSON.parse(JSON.stringify(this.eDeliveryService.listOfAccountsChanged));
        // Generate copy of accounts so that when hitting the back button we can have the latest state.
        this.eDeliveryService.stateCopyOfAccounts = JSON.parse(JSON.stringify(this.eDeliveryService.listOfAccountsChanged));

        for (let i = 0; i < listOfOriginalAccounts.accounts.length; i++) {
            for (let j = 0; j < listOfChangedAccounts.length; j++) {
                if (listOfOriginalAccounts.accounts[i].accountNumber === listOfChangedAccounts[j].accountNumber) {
                    selectedArray.length = 0;
                    selcCounter = 0;
                    for (let k = 0; k < listOfOriginalAccounts.accounts[i].edeliveryDocuments.length; k++) {
                        console.log('documents included: ', listOfOriginalAccounts.accounts[i].edeliveryDocuments[k].documentsIncluded);
                        let originalDocs = listOfOriginalAccounts.accounts[i].edeliveryDocuments[k];
                        let changedDocs = listOfChangedAccounts[j].edeliveryDocuments[k];
                        if (changedDocs.edocumentType.docTypeCd === 'PRXY') {
                            // let tempProxy = changedAccountDocuments[j];
                             if ((originalDocs.preferenceType.deliveryPreference !== changedDocs.preferenceType.deliveryPreference) && changedDocs.preferenceType.deliveryPreference === 2) {
                                changedDocs.pin = this.defaultPinValue;
                             }
                        }
                        if (changedDocs.preferenceType.deliveryPreference === 4 && changedDocs.docEligible && this.eDeliveryService.isNXIRequest()) {
                            changedDocs.preferenceType.deliveryPreference = 2;
                            changedDocs.preferenceType.preferenceCode = 'ONLINE';
                            changedDocs.preferenceType.preferenceCodeMF = 'E';
                            let currentEmail = listOfChangedAccounts[j].externalEmailAddr;
                            if (changedDocs.edocumentType.docTypeCd === 'PROS' && (currentEmail === null || currentEmail === '')) {
                                listOfChangedAccounts[j].externalEmailAddr = this.eDeliveryService.externalEmail;
                            }
                            if (changedDocs.edocumentType.docTypeCd === 'PRXY' && (currentEmail === null || currentEmail === '')) {
                                listOfChangedAccounts[j].externalEmailAddr = this.eDeliveryService.externalEmail;
                            }
                        }
                        if (originalDocs.preferenceType.deliveryPreference === changedDocs.preferenceType.deliveryPreference) {
                            selectedArray[selcCounter++] = k;
                        } else {
                            // Enable flag that checks if enrolled.
                            if (listOfChangedAccounts[j].edeliveryDocuments[k].preferenceType.deliveryPreference === 2 ||
                                listOfChangedAccounts[j].edeliveryDocuments[k].preferenceType.deliveryPreference === 4) {
                                this.didUserEnroll = true;
                            }
                        }
                    }
                    for (let m = selcCounter - 1; m >= 0; m--) {
                        listOfChangedAccounts[j].edeliveryDocuments.splice(selectedArray[m], 1);
                    }
                    break;
                }
            }
        }
        this.eDeliveryService.finalListOfAccounts = listOfChangedAccounts;
        // Add accounts whose email was changed.
        this.addEmailOrPinPref(this.eDeliveryService.accountsWithChangedEmails);
        // Reset backButton flag
        this.eDeliveryService.backButtonClicked = false;

        console.log('this.eDeliveryService.finalListOfAccounts, ', this.eDeliveryService.finalListOfAccounts);
        // If enrolling then go to agreement
        if (this.didUserEnroll && this.eDeliveryService.isNXIRequest()) {
            this.eDeliveryService.goToAgreement();
        } else { // Otherwise call update service.submitPreferences() directly
            if (!this.updatePreferencesInProgressFlag) {
             this.updatePreferencesInProgressFlag = true;
            } else {
             return;
            }
            this.eDeliveryService.submitPreferences();
            this.confirmationSubscription = this.eDeliveryService.confirmationResponse$.subscribe(confirmResponse => {
                console.log('confirmResponse: ', confirmResponse);
                if (confirmResponse.accounts !== undefined) {
                    this.eDeliveryService.accountsWithChangedEmails = [];
                    this.eDeliveryService.finalListOfAccounts = [];
                    this.eDeliveryService.disableEnrollButtonInEdit(true);
                    // this.eDeliveryService.retrievePreferences();
                    this.documentsPending = false;
                    // this.eDeliveryService.documentsPending = false;
                    this.dialogRef.close();
                    this.dialog.open(ConfirmationComponent, { panelClass: ['modal', 'edel-Confirmation'], width: '40vw', data: confirmResponse });
                    this.updatePreferencesInProgressFlag = false;
                }
            },
            error => {
                this.updatePreferencesInProgressFlag = false;
                this.setError(error);
            });
        }
    }

    addEmailOrPinPref (accounts) {
        if (accounts.length > 0) {
            for (let i = 0; i < accounts.length; i++) {
                // If user de-enrolled, then don't add since it will already have been added.
                let arrayCopyOfDocuments = [];
                for (let j = 0; j < accounts[i].edeliveryDocuments.length; j++) {
                    let document = accounts[i].edeliveryDocuments[j];
                    if (document.preferenceType.deliveryPreference === 2) {
                        arrayCopyOfDocuments.push(document);
                    }
                }
                if (arrayCopyOfDocuments.length !== 0) {
                    accounts[i].edeliveryDocuments = arrayCopyOfDocuments;
                    this.checkIfAccountExists(accounts[i]);
                }
            }
        }
    }

    checkIfAccountExists(account) {
        for (let i = 0; i < this.eDeliveryService.finalListOfAccounts.length; i++) {
            let originalChangedAccount = this.eDeliveryService.finalListOfAccounts[i];
            if (originalChangedAccount.accountNumber === account.accountNumber) {
                // Add the only preference which was changed by email.
                for (let j = 0; j < account.edeliveryDocuments.length; j++) {
                    let docTypeName = account.edeliveryDocuments[j].edocumentType.docTypeCd;
                    this.checkIfDocumentExists(originalChangedAccount, account, docTypeName, j);
                }
                return;
            }
        }
        this.eDeliveryService.finalListOfAccounts.push(account);
    }

    checkIfDocumentExists(originalChangedAccount, account, checkingTypeName, index) {
        let itExists = false;
        for (let k = 0; k < originalChangedAccount.edeliveryDocuments.length; k++) {
            if (checkingTypeName === originalChangedAccount.edeliveryDocuments[k].edocumentType.docTypeCd) {
                itExists = true;
            }
        }
        if (!itExists) {
            originalChangedAccount.externalEmailAddr = account.externalEmailAddr;
            originalChangedAccount.edeliveryDocuments.push(account.edeliveryDocuments[index]);
        }
    }

    getGridHeight() {
        if (this.numberOfRows === 1) {
            return '26vh';
        } else {
            // if (window.outerHeight < 500) {
            //     let height = this.numberOfRows * 340;
            //     let retVal = height + 'px';
            //     return retVal;
            // } else {
            //     // return '800vh';
            //     let height = this.numberOfRows * 45;
            //     let retVal = height + 'vh';
            //     return retVal;
            // }
            // return (this.numberOfRows * 345) + 'px';
            let gridHeight: number = 60;
            if (this.gridOptions.api) {
                let renderedRows = this.gridOptions.api.getRenderedNodes();
                if (renderedRows.length > 0) {
                    for (let i = 0; i < renderedRows.length; i++) {
                        let row = renderedRows[i];
                        console.log('rowHeight is ' + row.rowHeight);
                        gridHeight += row.rowHeight;
                    }
                } else {
                    gridHeight = this.gridHeightVal;
                }
                this.gridHeightVal = gridHeight;
                return gridHeight + 'px';
            } else {
                return this.gridHeightVal + 'px';
            }
        }
    }

    close() {
        // this.response = this.originalResponse;
        // this.gridOptions.api.setRowData(this.formatRowData(this.originalResponse));
        // this.pershingGridControllerComponent.updatePaginationDisplay(pageRecords.length, this.pageNumber);
        this.eDeliveryService.backButtonClicked = false;
        this.eDeliveryService.triggerRefresh();
        // this.response.data[0].edeliveryDocuments[0].documentPreference = 1;
        // this.eDeliveryService.resetPreferences();
        this.dialogRef.close();
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'confirmationSubscription', errorCode));
    }
}
